var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642 4141 c-66 -23 -117 -63 -159 -125 -43 -63 -56 -116 -51 -201 8 -116 71 -211 176 -262 l57 -28 1895 0 1895 0 57 28 c62 30 115 83 150 149 19 36 23 58 23 138 0 80 -4 102 -23 138 -35 66 -88 119 -150 149 l-57 28 -1880 2 c-1801 2 -1882 2 -1933 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 2861 c-66 -23 -117 -63 -159 -125 -43 -63 -56 -116 -51 -201 8 -116 71 -211 176 -262 l57 -28 1895 0 1895 0 57 28 c62 30 115 83 150 149 19 36 23 58 23 138 0 80 -4 102 -23 138 -35 66 -88 119 -150 149 l-57 28 -1880 2 c-1801 2 -1882 2 -1933 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 1581 c-66 -23 -117 -63 -159 -125 -43 -63 -56 -116 -51 -201 8 -116 71 -211 176 -262 l57 -28 1895 0 1895 0 57 28 c62 30 115 83 150 149 19 36 23 58 23 138 0 80 -4 102 -23 138 -35 66 -88 119 -150 149 l-57 28 -1880 2 c-1801 2 -1882 2 -1933 -16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.c4a65333b715b47b01e28f3120be7fa3.svg";
export { ForwardRef as ReactComponent };